<template>
  <div class="container">
    <div class="row">

      <div class="col-12 d-none">
        <img :src="`/img/logo_sk.svg`" :alt="$t('main-logo-title-alt')" class="img-fluid footer-logo-brand" lazyload width="300" height="25">
      </div>

      <div class="col-6 col-md-6 col-lg-4 col-xl-3 mb-4 footer_t"
           v-for="menuItem in content.filter(m => m.class === 'footer_top')">

        <p class="menu-col-title">{{ menuItem.name }}</p>

        <template v-if="menuItem.hasChilds()">
          <template v-for="subMenu in menuItem.childs">
            <a v-if="subMenu.class.indexOf('phone') >= 0"
               rel="index" :title="subMenu.name" class="d-block" :href="`tel:${subMenu.link}`" target="_self">
              {{ subMenu.name }}
            </a>
            <a v-else-if="subMenu.class.indexOf('email') >= 0"
               rel="index" :title="subMenu.name" class="d-block" :href="`mailto:${subMenu.link}`" target="_self">
              {{ subMenu.name }}
            </a>
            <NuxtLink :key="subMenu.id" v-else
                      rel="index" :title="subMenu.name" class="d-block" :to="subMenu.getLinkWithSlash()"
                      :target="subMenu.link.indexOf('http') === 0 ? '_blank' : '_self'">
              {{ subMenu.name }}
            </NuxtLink>
          </template>
        </template>
      </div>
    </div>
    <div class="d-none row mb-lg-0 border-top pb-5 align-content-end">
      <div class="col-12 col-md-12 col-xl-4 text-start order-2 order-xl-0 mt-3">
            <span class="copywrite text-muted">
                <small class="me-2">© {{ (new Date()).getFullYear() }}</small>
                <span class="author me-2"><small>
                  <a href="https://www.webforrent.sk" target="_blank"
                     :title="$t('tvorba-webstranok-footer')">WebforRent.sk</a></small></span>
                <small>{{ $t('all-rights-reserved') }}</small>
            </span>
      </div>
      <div class="col-12 col-md-4 col-xl-3 order-0 order-xl-1 mt-3">
        <div class="item">
          <a class="h5 text-capitalize pointer"
             v-for="menuItem in content.filter(m => m.class === 'footer_bottom')">{{ menuItem.name }}<span
              class="dot">·</span></a>
        </div>
      </div>
      <div class="d-none col-12 col-md-8 col-xl-5 text-md-end order-1 order-xl-2 mt-3">
        <div class="row">
          <div class="col-7 d-none">
            <span class="h5 text-capitalize pointer ms-0 ps-0 d-inline">
              <TyIcon icon='ty-language' class="icon-color-second me-2" height="1rem" width="1rem"/>
              <span>jazyk</span></span>
            <span class="h5 text-capitalize pointer">
              <TyIcon icon='ty-euro-money' class="icon-color-second ms-3 me-2" height="1rem" width=".7rem"/>
              <span>EUR</span></span>

          </div>
          <div class="col-7 d-none"></div>
          <div class="col-5 text-end d-none">
            <a class="h5" href="https://www.instagram.com/hladamchatu.sk" rel="nofollow" title="hladamchatu-instagram"
               target="_blank">
              <TyIcon icon='ty-instagram' class="icon-color-second ms-2 ms-md-3 pointer" height="1.5rem"
                      width="1.5rem"/>
            </a>
            <a class="h5" href="https://www.facebook.com/hladamchatu" rel="nofollow" title="hladamchatu-facebook"
               target="_blank">
              <TyIcon icon='ty-facebook' class="icon-color-second ms-2 ms-md-3 pointer" height="1.5rem" width="1.5rem"/>
            </a>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>


<script setup lang="ts">
import {computed, PropType} from "vue";
import {PageDataHolderFetchedWidget} from "~/lib/interfaces/model/PageDataHolderFetchedWidget";
import {useWidget} from "../../../../composables/widget/menu";

const props = defineProps({
  widget: Object as PropType<PageDataHolderFetchedWidget>
});

const {content} = useWidget(props.widget);
</script>
